<template>
    <div class="tree-warp">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <div class="tree-content_box">
            <div class="tree-content tree-container">
                <el-tree style="overflow: none !important" ref="tree" class="tree" :data="data" :indent="0" :show-checkbox="checkbox" node-key="id" :expand-on-click-node="false"
                    :highlight-current="true" :default-expand-all="defaultExpandedAll" :default-checked-keys="defaultCheckedKeys" :filter-node-method="filterNode" 
                    :check-strictly="checkStrictly" @node-click="bindNodeClick" @check="bindCheckChange">
                    <span class="span-ellipsis" slot-scope="{node,data}">
                        <span :data="data" :title="node.label">{{ node.label }}</span>
                    </span>
                </el-tree>
            </div>
        </div>
    </div>
</template>
<script>
import * as utils from '@/utils/index.js'
export default {
    props: {
        data: {
            type: Array,
            default: () => []
        },
        checkbox: {
            type: Boolean,
            default: false
        },
        defaultExpandedKeys: {
            type: Array,
            default: () => []
        },
        defaultCheckedKeys: {
            type: Array,
            default: () => []
        },
        defaultExpandedAll: {
            type: Boolean,
            default: false
        },
        checkStrictly: {
            type: Boolean,
            default: false
        },
        defaultCurrent: {
            type: Boolean,
            default: false
        },
        isExpand: {
            type: Boolean,
            default: false
        },
        /**
         * 是否关系型
         */
        isRelation: {
            type: Boolean,
            default: true
        },
        /**
         * 最多可选
         */
        mostChecked: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            filterText: '',
            expand: ''
        }
    },
    created() {
        if (this.data.length > 0 && this.defaultCurrent == true) {
            this.$nextTick(() => {
                this.defaultCheckedKeys = [this.data[0].id]
            })
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
        data(val) {
            this.data = val
            if (val.length > 0 && this.defaultCurrent == true) {
                this.$nextTick(() => {
                    this.defaultCheckedKeys = [this.data[0].id]
                })
            }
        }
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        bindNodeClick(data, node, ev) {
            if (data.id !== '-1') {
                this.$emit('click', data) //反馈给父组件
            }
        },
        bindCheckChange() {
            let vm = this
            let data = vm.$refs.tree.getCheckedNodes(false, vm.isRelation);
            let ids = []
            //判断最大选中
            if (vm.mostChecked !== null) {
                if (data.length > vm.mostChecked) {
                    this.$message('最多可选择' + vm.mostChecked + '个！');
                    for (let index = 0; index < data.length - vm.mostChecked; index++) {
                        vm.$refs.tree.setChecked(data[index].id, false, false);
                        data.splice(index, 1);
                    }
                }
            }
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                ids.push(element.id);
            }
            let selectNodeIdArr = vm.getTreeArrId(data);
            let selectNodeArr = vm.getTreeArr(data);
            this.$emit('change', selectNodeIdArr, ids, selectNodeArr) //反馈给父组件
        },
        getTreeArrId(data) {
            let selectNodeIdArr = []
            for (let index = 0; index < data.length; index++) {
                const element = data[index]
                selectNodeIdArr.push({
                    id: element.id,
                    label: element.label
                });
            }
            return selectNodeIdArr;
        },
        getTreeArr(data) {
            let selectNodeIdArr = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                selectNodeIdArr.push(element);
            }
            return selectNodeIdArr;
        },
        getCheckedKeys() {
            let data = this.$refs.tree.getCheckedNodes(false, this.isRelation);
            let selectNodeIdArr = this.getTreeArrId(data);
            return selectNodeIdArr;
        },
        getfistkey() {
            let data = this.$refs.tree.getCheckedNodes(false, true)
            return data
        },
        setCancelChecked(data) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                this.$refs.tree.setChecked(element.id, false, true);
            }
        },
        setTreeNodeSelect(id) {
            this.$refs.tree.setCurrentKey(id);
            this.$refs.tree.defaultExpandedKeys = [id];
        },
        getCheckedNodes() {
            return this.$refs.tree.getCheckedNodes();
        }
    }
}
</script>

<style  scoped>
.tree-warp {
    position: relative;
    margin-top: 14px;
}
.el-tree {
    color: #1e1f1f;
    width: 100%;
    height: 100%;
}
.tree-content_box {
    position: absolute;
    top: 40px;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 14px;
    padding-top: 5px;
    box-sizing: border-box;
}
.tree-content_box ::v-deep .el-tree {
    overflow: none !important;
}
.tree-content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 5px;
}
.tree-container /deep/ .el-tree > .el-tree-node:after {
    border-top: none;
}

.tree /deep/ .el-tree-node {
    position: relative;
    padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
    padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
    height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
    border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
    border-top: none;
}

.tree /deep/ .el-tree-node:before {
    content: '';
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
    content: '';
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
}

.tree /deep/ .el-tree-node:before {
    border-left: 1px dashed #bebebe;
    bottom: 0px;
    height: 100%;
    top: -26px;
    width: 1px;
}

.tree /deep/ .el-tree-node:after {
    border-top: 1px dashed #bebebe;
    height: 20px;
    top: 12px;
    width: 24px;
}
</style>
<style>
.span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
}
.tree-content {
    background-color: #ffffff;
}
.tree-content .el-tree {
    min-width: 100%;
    font-size: 14px;
    text-align: left;
    display: inline-block !important;
}
</style>